// import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { THEME_COLORS } from '../utils/Constants';
import { WELCOME_PAGE } from '../utils/Colors';

const foodbookTheme = createMuiTheme({
    palette: {
        primary: { main: WELCOME_PAGE.primaryColor },
        // text: {primary: THEME_COLORS.ORANGE,secondary:'#ffffff'},

        // action:{active: SMARTQ_COLORS.SQ_THEME_PRESSED_COLOR},
        // background:SmartqColors.SQ_THEME_COLOR,
        // typography:{
        //     htmlFontSize:50,
        // }
    }
})

export default foodbookTheme;


// WEBPACK FOOTER //
// ./src/hoc/Theme.js